import {
  SquareDotLoadingIndicator,
  Text,
  TextButton,
} from '@joor/design-system'
import styled from 'styled-components'

import { sendPaymentRequestIds } from '../../orders.ids'

const InvoiceLoadingLabelContainer = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  margin-left: -12px;
`

const LoaderStyled = styled(SquareDotLoadingIndicator)`
  transform: scale(0.5);
  width: 48px;
  height: 48px;
  > div {
    margin-top: 0 !important;
  }
`

const WrappedTextButton = styled(TextButton)`
  font-weight: var(--font-weight-medium);
  font-size: var(--size-font-extrasmall);
  line-height: var(--line-height-16);
  letter-spacing: var(--letter-spacing-tight);
  margin-left: 4px;
`

interface InvoiceLoadingLabelProps {
  isTakingMoreTime?: boolean
  handleStopPolling: () => void
}

const InvoiceLoadingLabel = ({
  isTakingMoreTime,
  handleStopPolling,
}: InvoiceLoadingLabelProps) => (
  <InvoiceLoadingLabelContainer>
    <LoaderStyled />
    {isTakingMoreTime ? (
      <>
        <Text
          fontSize="extrasmall"
          fontWeight="medium"
          lineHeight="12"
          letterSpacing="tight"
          color="warning-800"
        >
          Request is taking longer than expected.
        </Text>
        <WrappedTextButton
          id={sendPaymentRequestIds.cancelAttachJoorInvoice}
          onClick={() => handleStopPolling()}
        >
          Cancel?
        </WrappedTextButton>
      </>
    ) : (
      <Text
        fontSize="extrasmall"
        fontWeight="medium"
        lineHeight="12"
        letterSpacing="tight"
        color="primary-400"
      >
        We are generating your invoice and will attach it to the request once it
        is ready. This may take a few seconds.
      </Text>
    )}
  </InvoiceLoadingLabelContainer>
)

export default InvoiceLoadingLabel
